<div class="row">
  <div class="col-md-12">
    <div
      ng2FileDrop
      [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
      (fileOver)="fileOverBase($event)"
      (onFileDrop)="onFileDropped($event)"
      [uploader]="uploader"
      class="well drop-zone"
    >
      <label class="file-drop-area text-muted text-center">
        <i class="fa font-5xl fa-upload"></i><br />{{visuals.droparea}}
        <input
          #fileUpload
          type="file"
          ng2FileSelect
          [uploader]="uploader"
          (change)="onFileSelected($event)"
          class="custom-file-input"
          style="display: none;"
        />
      </label>
    </div>
    <div *ngIf="quequeMsg" class="text-danger text-center">
      {{quequeMsg}}
    </div>
  </div>
</div>

<div *ngIf="uploader?.queue?.length > 0">
  <div class="card-block">
    <div class="row">
      <div
        class="col-sm-4 col-lg-3 mx-auto"
        style="display: block;"
        *ngFor="let item of uploader.queue"
      >
        <div class="media-items animation-fadeInQuick2">
          <div class="media-items-content">
            <i class="fa fa-file-text-o fa-5x text-primary"></i>
          </div>
          <p style="word-wrap: break-word;">
            <strong>{{ item?.file?.name | slice:0:50 }}</strong>
          </p>
          <button
            type="button"
            class="btn btn-success btn-xs"
            (click)="uploadCustom(item)"
            [disabled]="item.isReady || item.isUploading || item.isSuccess || uploading"
          >
            <span class="fa fa-upload" title="{{visuals.upload}}"></span>
          </button>

          <button
            type="button"
            class="btn btn-danger btn-xs"
            (click)="removeCustom(item)"
            [disabled]="uploading"
          >
            <span class="fa fa-close" title="{{visuals.remove}}"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngFor="let item of uploader.queue">
  <div
    [ngClass]="{'inline-error': item.isError, 'inline-success': !item.isError}"
    *ngIf=" !uploading && (item.isSuccess || item.isError)"
  >
    <i *ngIf="!item.isError" class="fa fa-check fa-lg"></i>
    <i
      *ngIf="item.isError"
      class="fa fa-exclamation  error-btn"
      title="{{visuals.errorDetails}}"
    ></i>
    <span *ngIf="!item.isError"> Success </span>
    <span *ngIf="item.isError">
      {{error.message}}
    </span>
  </div>
</div>

<div *ngIf="uploading" class="dataLoader"></div>
